module.exports = __webpack_public_path__ + "img/img2.faef5495.png";